<template>
	<q-card>
		<q-toolbar>
			<q-toolbar-title v-if="!presential.user_subscribed">{{
				$t('register_for_the_presential_class')
			}}</q-toolbar-title>

			<q-toolbar-title v-if="presential.user_subscribed">{{
				$t('unsubscribe_from_the_presential_class')
			}}</q-toolbar-title>

			<q-btn flat round dense icon="fal fa-times" v-close-popup />
		</q-toolbar>

		<q-separator />

		<q-card-section>
			<div class="row" v-if="!presential.user_subscribed">
				<div class="col-12 q-mb-lg" v-if="presential.event_dates.length">
					<q-table
						grid
						hide-bottom
						row-key="name"
						:dense="$q.screen.lt.md"
						:title="$t('events')"
						:columns="columns"
						:rows="presential.event_dates"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
					>
						<template v-slot:header="props">
							<q-tr :props="props">
								<q-th v-for="col in props.cols" :key="col.name" :props="props">
									{{ $t(col.label) }}
								</q-th>
							</q-tr>
						</template>
						<template v-slot:body="props">
							<q-tr>
								<q-td key="presential_event_date_type_slug" :props="props">
									{{ $t(props.row.presential_event_date_type_slug) }}
								</q-td>

								<q-td key="event_date" :props="props">
									{{ $dateUtil.fDate(props.row.event_date) }}
								</q-td>

								<q-td key="hr_start" :props="props">
									{{ $dateUtil.fTimeTimezoneFormated(props.row.hr_start, presential.timezone) }}
								</q-td>

								<q-td key="hr_end" :props="props">
									{{ $dateUtil.fTimeTimezoneFormated(props.row.hr_end, presential.timezone) }}
								</q-td>
							</q-tr>
						</template>
					</q-table>
				</div>

				<div class="row" v-if="hasPresentialEvent">
					<div class="col-12 title-h6 text-weight-bold">
						{{ $t('address') }}
					</div>

					<div class="col-12">
						{{
							`${presential.address.address}, ${presential.address.number} ${
								presential.address.complement ? ` (${presential.address.complement})` : ''
							} - ${presential.address.neighborhood}`
						}}
					</div>

					<div class="col-12 q-mb-lg">
						{{ `${presential.address.city} - ${presential.address.state}` }}
					</div>
				</div>

				<div class="col-12 text-weight-bold">
					{{ $t('check_your_availability_at_all_times_before_confirming_your_presence') }}
				</div>

				<div class="col-12">
					{{
						$t('do_you_confirm_your_registration_for_the_presential_class', {
							title: presential.title,
						})
					}}
				</div>
			</div>
		</q-card-section>

		<q-card-section class="q-pt-none" v-if="!presential.user_subscribed">
			<q-checkbox
				v-model="subscribe_presential_emails"
				:label="$t('receive_emails_about_this_presential_class')"
			/>
		</q-card-section>

		<q-card-section v-if="presential.user_subscribed">
			{{
				$t('do_you_confirm_your_unsubscription_to_the_presential_class', {
					title: presential.title,
				})
			}}
		</q-card-section>

		<q-card-actions align="right">
			<q-btn :label="$t('cancel')" color="negative" outline v-close-popup />
			<q-btn :label="$t('confirm')" color="positive" @click="subscribePresential()" v-close-popup />
		</q-card-actions>
	</q-card>
</template>

<script>
export default {
	name: 'ConfirmSubscribePresential',

	props: ['presential'],

	data() {
		return {
			columns: [
				{
					align: 'left',
					field: 'presential_event_date_type_slug',
					label: 'event_type',
					name: 'presential_event_date_type_slug',
					sortable: false,
				},
				{
					align: 'center',
					field: 'event_date',
					label: 'date',
					name: 'event_date',
					sortable: false,
				},
				{
					align: 'center',
					field: 'hr_start',
					label: 'start_time',
					name: 'hr_start',
					sortable: false,
				},
				{
					align: 'center',
					field: 'hr_end',
					label: 'end_time',
					name: 'hr_end',
					sortable: false,
				},
			],
			subscribe_presential_emails: true,
		}
	},

	computed: {
		hasPresentialEvent() {
			if (this.presential) {
				return this.presential.event_dates.find((e) => e.presential_event_date_type === 1)
					? true
					: false
			}
			return false
		},
	},

	methods: {
		subscribePresential() {
			this.$q.loading.show()

			let fd = new FormData()
			fd.append('receive_notifications', this.subscribe_presential_emails)

			const url =
				this.$route.name !== 'presentials_catalogs'
					? `/etraining_presential/presential/${this.presential.id}/save_subscription/`
					: `/etraining_trails/trail/${this.$route.params.id_trail}/presential_event_catalog/${this.$route.params.id}/presential/${this.presential.id}/save_subscription/`

			this.$axios
				.post(url, fd)
				.then((response) => {
					if (response.data.orientation === 'subscribed') {
						this.presential.user_subscribed = true

						this.$q.notify({
							message: this.$t('successfully_signed_up_for_the_presential_class'),
							type: 'positive',
							icon: 'fal fa-calendar-plus',
						})
					} else {
						this.presential.user_subscribed = false

						this.$q.notify({
							message: this.$t('unsubscribe_successfully_for_the_presential_class'),
							type: 'positive',
							icon: 'fal fa-calendar-minus',
						})
					}
				})
				.catch((e) => {
					if (e.response.data.orientation === 'no_vacancy') {
						this.$q.notify({
							message: this.$t('no_vacancy'),
							type: 'negative',
							icon: 'fal fa-users-slash',
							position: 'top',
						})
						return
					} else console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
					this.show_confirm_subscribe_presential = false

					this.$emit('hideConfirmSubscribePresential')
					this.$mitt.emit('reloadSubscribedPresential')
				})
		},
	},
}
</script>

<style></style>
